/**
 * Menu item configurations for desktop and mobile
 */
import {
	PATH_HOME,
	PATH_EMPLOYEE,
	PATH_APPLICANTS,
	PATH_TRAINING_COURSES,
	PATH_TRAINING_PARTICIPANTS,
	PATH_TRAINING_CERTIFICATIONS,
	PATH_TRAINING_SUMMARY,
	PATH_TRAINING_MASS_UPDATE,
	PATH_ASSET_SENTINEL_DASHBOARD,
	PATH_ASSET_SENTINEL_FLEET_VEHICLES,
	PATH_ASSET_SENTINEL_FLEET_WORK_ORDERS,
	PATH_ASSET_SENTINEL_FLEET_INSPECTION,
	PATH_ASSET_SENTINEL_FLEET_INSPECTION_SETUP,
	PATH_ASSET_SENTINEL_EQUIPMENT,
	PATH_ASSET_SENTINEL_EQUIPMENT_MAINTENANCE,
	PATH_ASSET_SENTINEL_EQUIPMENT_DISPENSABLE_ITEMS,
	PATH_ASSET_SENTINEL_EQUIPMENT_DASHBOARD,
	PATH_ASSET_SENTINEL_FLEET_DASHBOARD,
	PATH_ASSET_SENTINEL_EQUIPMENT_FUNDING_SOURCES,
	PATH_ASSET_SENTINEL_FLEET_FUNDING_SOURCES,
	PATH_ASSET_SENTINEL_FLEET_VEHICLE_STATUS,
	PATH_ASSET_SENTINEL_FLEET_WORK_ORDER_TYPES,
	PATH_ASSET_SENTINEL_FLEET_WORK_ORDER_STATUS,
	PATH_ASSET_SENTINEL_FLEET_VEHICLE_SERVICE_REQUIREMENTS,
	PATH_ASSET_SENTINEL_EQUIPMENT_TYPES,
	PATH_ASSET_SENTINEL_EQUIPMENT_SERVICE_REQUIREMENTS,
	PATH_ASSET_SENTINEL_EQUIPMENT_CATEGORY,
	PATH_ASSET_SENTINEL_EQUIPMENT_CONDITIONS,
	PATH_ASSET_SENTINEL_EQUIPMENT_STATUS,
	PATH_TRAINING_DASHBOARD,
} from "../utils/routeConstants";

export const assetSentinelMenu = [
	{
		label: "Home",
		tooltip: "Home",
		link: PATH_ASSET_SENTINEL_DASHBOARD,
		icon: "home",
		alwaysVisible: true,
	},
	{
		label: "Employees",
		tooltip: "Employees",
		link: PATH_EMPLOYEE,
		icon: "users",
		permission: { area: "modules", key: "Employees" },
	},
	{
		label: "Fleet",
		tooltip: "Fleet",
		link: PATH_ASSET_SENTINEL_FLEET_DASHBOARD,
		icon: "truck",
		isAssetSentinelModule: true,
		permission: { area: "modules", key: "Fleet" },
		subMenu: [
			{
				label: "Dashboard",
				tooltip: "Dashboard",
				link: PATH_ASSET_SENTINEL_FLEET_DASHBOARD,
				icon: "home",
				alwaysVisible: true,
				// permission: { area: "equipment", key: "Equipment" },
			},
			{
				label: "Fleet Vehicles",
				tooltip: "Fleet Vehicles",
				icon: "car",
				link: PATH_ASSET_SENTINEL_FLEET_VEHICLES,
				permission: { area: "fleet", key: "Vehicles" },
			},
			{
				label: "Work Orders",
				tooltip: "Work Orders",
				icon: "wrench",
				link: PATH_ASSET_SENTINEL_FLEET_WORK_ORDERS,
				permission: { area: "fleet", key: "Work Orders" },
			},
			{
				label: "Inspections",
				tooltip: "Inspections",
				icon: "check-circle",
				link: PATH_ASSET_SENTINEL_FLEET_INSPECTION,
				permission: { area: "fleet", key: "Inspections" },
			},
			{
				label: "Inspection Setup",
				tooltip: "Inspection Setup",
				icon: "check-square",
				link: PATH_ASSET_SENTINEL_FLEET_INSPECTION_SETUP,
				permission: { area: "fleet", key: "Inspections Setup" },
			},
			{
				label: "Funding Source",
				tooltip: "Funding Source",
				icon: "wallet",
				link: PATH_ASSET_SENTINEL_FLEET_FUNDING_SOURCES,
				permission: { area: "fleet", key: "Funding Sources" },
			},
			{
				label: "Code Maintenance",
				tooltip: "Code Maintenance",
				icon: "cog",
				link: PATH_ASSET_SENTINEL_FLEET_VEHICLE_STATUS,
				permission: { area: "fleet", key: "Code Maintenance" },
				subMenu: [
					{
						label: "Vehicle Status",
						tooltip: "Vehicle Status",
						link: PATH_ASSET_SENTINEL_FLEET_VEHICLE_STATUS,
						// icon: <DirectionsCar />,
						permission: { area: "codes", key: "Vehicle Statuses" },
						data: {
							serviceName: "code-per-vehicle-status",
							stateName: "vehicleStatusCodes",
							tableName: "Vehicle Status Codes",
							columnOrderKey: "vehicleStatusCodeTableColumnOrder",
							columnSizeKey: "vehicleStatusCodeTableColumnSizes",
							columnVisibilityKey:
								"vehicleStatusCodeTableColumnVisibility",
							tableSortModelKey:
								"vehicleStatusCodeTableSortModel",
							title: "Vehicle Status",
						},
					},
					{
						label: "Work Order Types",
						tooltip: "Work Order Types",
						link: PATH_ASSET_SENTINEL_FLEET_WORK_ORDER_TYPES,
						// icon: <Build />,
						permission: { area: "codes", key: "Work Order Types" },
						data: {
							serviceName: "code-per-work-order-types",
							stateName: "workOrderTypesCodes",
							tableName: "Work Order Types Codes",
							columnOrderKey:
								"workOrderTypesCodeTableColumnOrder",
							columnSizeKey: "workOrderTypesCodeTableColumnSizes",
							columnVisibilityKey:
								"workOrderTypesCodeTableColumnVisibility",
							tableSortModelKey:
								"workOrderTypesCodeTableSortModel",
							title: "Work Order Types",
						},
					},
					{
						label: "Work Order Statuses",
						tooltip: "Work Order Statuses",
						link: PATH_ASSET_SENTINEL_FLEET_WORK_ORDER_STATUS,
						// icon: <Assignment />,
						permission: {
							area: "codes",
							key: "Work Order Statuses",
						},
						data: {
							serviceName: "code-per-work-order-status",
							stateName: "workOrderStatusCodes",
							tableName: "Work Order Status Codes",
							columnOrderKey:
								"workOrderStatusCodeTableColumnOrder",
							columnSizeKey:
								"workOrderStatusCodeTableColumnSizes",
							columnVisibilityKey:
								"workOrderStatusCodeTableColumnVisibility",
							tableSortModelKey:
								"workOrderStatusCodeTableSortModel",
							title: "Work Order Status",
						},
					},
					{
						label: "Vehicle Service Requirements",
						tooltip: "Vehicle Service Requirements",
						link: PATH_ASSET_SENTINEL_FLEET_VEHICLE_SERVICE_REQUIREMENTS,
						// icon: <CarRepair />,
						permission: {
							area: "codes",
							key: "Vehicle Service Requirements",
						},
						data: {
							serviceName:
								"code-per-vehicle-service-requirements",
							stateName: "vehicleServiceRequirementsCodes",
							tableName: "Vehicle Service Requirements Codes",
							columnOrderKey:
								"vehicleServiceRequirementsCodeTableColumnOrder",
							columnSizeKey:
								"vehicleServiceRequirementsCodeTableColumnSizes",
							columnVisibilityKey:
								"vehicleServiceRequirementsCodeTableColumnVisibility",
							tableSortModelKey:
								"vehicleServiceRequirementsCodeTableSortModel",
							title: "Vehicle Service Requirements",
						},
					},
				],
			},
		],
	},
	{
		label: "Equipment",
		tooltip: "Equipment",
		link: PATH_ASSET_SENTINEL_EQUIPMENT_DASHBOARD,
		isAssetSentinelModule: true,
		icon: "toolbox",
		permission: { area: "modules", key: "Equipment" },
		subMenu: [
			{
				label: "Dashboard",
				tooltip: "Dashboard",
				link: PATH_ASSET_SENTINEL_EQUIPMENT_DASHBOARD,
				icon: "home",
				alwaysVisible: true,
				// permission: { area: "equipment", key: "Equipment" },
			},
			{
				label: "Equipment",
				tooltip: "Equipment",
				link: PATH_ASSET_SENTINEL_EQUIPMENT,
				icon: "toolbox",
				permission: { area: "equipment", key: "Equipment" },
			},
			{
				label: "Maintenance",
				tooltip: "Maintenance",
				link: PATH_ASSET_SENTINEL_EQUIPMENT_MAINTENANCE,
				icon: "tools",
				permission: { area: "equipment", key: "Maintenance" },
			},
			{
				label: "Dispensable Items",
				tooltip: "Dispensable Items",
				link: PATH_ASSET_SENTINEL_EQUIPMENT_DISPENSABLE_ITEMS,
				icon: "box",
				permission: { area: "equipment", key: "Dispensable Items" },
			},
			{
				label: "Funding Source",
				tooltip: "Funding Source",
				icon: "wallet",
				link: PATH_ASSET_SENTINEL_EQUIPMENT_FUNDING_SOURCES,
				permission: { area: "equipment", key: "Funding Sources" },
			},
			{
				label: "Code Maintenance",
				tooltip: "Code Maintenance",
				icon: "cog",
				link: PATH_ASSET_SENTINEL_EQUIPMENT_TYPES,
				permission: { area: "equipment", key: "Code Maintenance" },
				subMenu: [
					{
						label: "Equipment Types",
						tooltip: "Equipment Types",
						link: PATH_ASSET_SENTINEL_EQUIPMENT_TYPES,
						// icon: <Settings />,
						permission: { area: "codes", key: "Equipment Types" },
						data: {
							serviceName: "code-per-equipment-types",
							stateName: "equipmentTypesCodes",
							tableName: "Equipment Types Codes",
							columnOrderKey:
								"equipmentTypesCodeTableColumnOrder",
							columnSizeKey: "equipmentTypesCodeTableColumnSizes",
							columnVisibilityKey:
								"equipmentTypesCodeTableColumnVisibility",
							tableSortModelKey:
								"equipmentTypesCodeTableSortModel",
							title: "Equipment Types",
						},
					},
					{
						label: "Equipment Statuses",
						tooltip: "Equipment Statuses",
						link: PATH_ASSET_SENTINEL_EQUIPMENT_STATUS,
						// icon: <CheckCircle />,
						permission: {
							area: "codes",
							key: "Equipment Statuses",
						},
						data: {
							serviceName: "code-per-equipment-status",
							stateName: "equipmentStatusCodes",
							tableName: "Equipment Status Codes",
							columnOrderKey:
								"equipmentStatusCodeTableColumnOrder",
							columnSizeKey:
								"equipmentStatusCodeTableColumnSizes",
							columnVisibilityKey:
								"equipmentStatusCodeTableColumnVisibility",
							tableSortModelKey:
								"equipmentStatusCodeTableSortModel",
							title: "Equipment Status",
						},
					},
					{
						label: "Equipment Conditions",
						tooltip: "Equipment Conditions",
						link: PATH_ASSET_SENTINEL_EQUIPMENT_CONDITIONS,
						// icon: <Report />,
						permission: {
							area: "codes",
							key: "Equipment Conditions",
						},
						data: {
							serviceName: "code-per-equipment-conditions",
							stateName: "equipmentConditionsCodes",
							tableName: "Equipment Conditions Codes",
							columnOrderKey:
								"equipmentConditionsCodeTableColumnOrder",
							columnSizeKey:
								"equipmentConditionsCodeTableColumnSizes",
							columnVisibilityKey:
								"equipmentConditionsCodeTableColumnVisibility",
							tableSortModelKey:
								"equipmentConditionsCodeTableSortModel",
							title: "Equipment Conditions",
						},
					},
					{
						label: "Equipment Category",
						tooltip: "Equipment Category",
						link: PATH_ASSET_SENTINEL_EQUIPMENT_CATEGORY,
						// icon: <Category />,
						permission: {
							area: "codes",
							key: "Equipment Category Codes",
						},
						data: {
							serviceName: "code-per-equipment-category",
							stateName: "equipmentCategoryCodes",
							tableName: "Equipment Category Codes",
							columnOrderKey:
								"equipmentCategoryCodeTableColumnOrder",
							columnSizeKey:
								"equipmentCategoryCodeTableColumnSizes",
							columnVisibilityKey:
								"equipmentCategoryCodeTableColumnVisibility",
							tableSortModelKey:
								"equipmentCategoryCodeTableSortModel",
							title: "Equipment Category",
						},
					},
					{
						label: "Equipment Service Requirements",
						tooltip: "Equipment Service Requirements",
						link: PATH_ASSET_SENTINEL_EQUIPMENT_SERVICE_REQUIREMENTS,
						// icon: <Engineering />,
						permission: {
							area: "codes",
							key: "Equipment Service Requirements",
						},
						data: {
							serviceName:
								"code-per-equipment-service-requirements",
							stateName: "equipmentServiceRequirementsCodes",
							tableName: "Equipment Service Requirements Codes",
							columnOrderKey:
								"equipmentServiceRequirementsCodeTableColumnOrder",
							columnSizeKey:
								"equipmentServiceRequirementsCodeTableColumnSizes",
							columnVisibilityKey:
								"equipmentServiceRequirementsCodeTableColumnVisibility",
							tableSortModelKey:
								"equipmentServiceRequirementsCodeTableSortModel",
							title: "Equipment Service Requirements",
						},
					},
				],
			},
		],
	},
];

const menuSettings = [
	{
		label: "Home",
		tooltip: "Home",
		link: PATH_HOME,
		icon: "home",
		alwaysVisible: true,
	},
	{
		label: "Applicants",
		tooltip: "Applicants",
		link: PATH_APPLICANTS,
		icon: "user-friends",
		permission: { area: "modules", key: "Applicants" },
	},
	{
		label: "Employees",
		tooltip: "Employees",
		link: PATH_EMPLOYEE,
		icon: "users",
		permission: { area: "modules", key: "Employees" },
	},
	{
		label: "Training",
		tooltip: "Training",
		link: PATH_TRAINING_DASHBOARD,
		icon: "user-graduate",
		permission: { area: "modules", key: "Training" },
		subMenu: [
			{
				label: "Dashboard",
				tooltip: "Dashboard",
				link: PATH_TRAINING_DASHBOARD,
				alwaysVisible: true,
			},
			{
				label: "Courses",
				tooltip: "Courses",
				link: PATH_TRAINING_COURSES,
				permission: { area: "training", key: "Courses" },
			},
			{
				label: "Training Records",
				tooltip: "Training Records",
				link: PATH_TRAINING_PARTICIPANTS,
				permission: { area: "training", key: "Participants" },
			},
			{
				label: "Certifications",
				tooltip: "Certifications",
				link: PATH_TRAINING_CERTIFICATIONS,
				permission: { area: "training", key: "Certifications" },
			},
			{
				label: "Mass Update Training Records",
				tooltip: "Mass Update Training Records",
				link: PATH_TRAINING_MASS_UPDATE,
				permission: { area: "training", key: "Mass Update" },
			},
			{
				label: "Training Summary",
				tooltip: "Training Summary",
				link: PATH_TRAINING_SUMMARY,
				permission: { area: "training", key: "Summary" },
			},
		],
	},
	{
		label: "Fleet",
		tooltip: "Fleet",
		link: PATH_ASSET_SENTINEL_FLEET_DASHBOARD,
		icon: "truck",
		isAssetSentinelModule: true,
		permission: { area: "modules", key: "Fleet" },
		subMenu: [
			{
				label: "Dashboard",
				tooltip: "Dashboard",
				link: PATH_ASSET_SENTINEL_FLEET_DASHBOARD,
				icon: "home",
				alwaysVisible: true,
				// permission: { area: "equipment", key: "Equipment" },
			},
			{
				label: "Fleet Vehicles",
				tooltip: "Fleet Vehicles",
				icon: "car",
				link: PATH_ASSET_SENTINEL_FLEET_VEHICLES,
				permission: { area: "fleet", key: "Vehicles" },
			},
			{
				label: "Work Orders",
				tooltip: "Work Orders",
				icon: "wrench",
				link: PATH_ASSET_SENTINEL_FLEET_WORK_ORDERS,
				permission: { area: "fleet", key: "Work Orders" },
			},
			{
				label: "Inspections",
				tooltip: "Inspections",
				icon: "check-circle",
				link: PATH_ASSET_SENTINEL_FLEET_INSPECTION,
				permission: { area: "fleet", key: "Inspections" },
			},
			{
				label: "Inspection Setup",
				tooltip: "Inspection Setup",
				icon: "check-square",
				link: PATH_ASSET_SENTINEL_FLEET_INSPECTION_SETUP,
				permission: { area: "fleet", key: "Inspections Setup" },
			},
			{
				label: "Funding Source",
				tooltip: "Funding Source",
				icon: "wallet",
				link: PATH_ASSET_SENTINEL_FLEET_FUNDING_SOURCES,
				permission: { area: "fleet", key: "Funding Sources" },
			},
			{
				label: "Code Maintenance",
				tooltip: "Code Maintenance",
				icon: "cog",
				link: PATH_ASSET_SENTINEL_FLEET_VEHICLE_STATUS,
				permission: { area: "fleet", key: "Code Maintenance" },
				subMenu: [
					{
						label: "Vehicle Status",
						tooltip: "Vehicle Status",
						link: PATH_ASSET_SENTINEL_FLEET_VEHICLE_STATUS,
						// icon: <DirectionsCar />,
						permission: { area: "codes", key: "Vehicle Statuses" },
						data: {
							serviceName: "code-per-vehicle-status",
							stateName: "vehicleStatusCodes",
							tableName: "Vehicle Status Codes",
							columnOrderKey: "vehicleStatusCodeTableColumnOrder",
							columnSizeKey: "vehicleStatusCodeTableColumnSizes",
							columnVisibilityKey:
								"vehicleStatusCodeTableColumnVisibility",
							tableSortModelKey:
								"vehicleStatusCodeTableSortModel",
							title: "Vehicle Status",
						},
					},
					{
						label: "Work Order Types",
						tooltip: "Work Order Types",
						link: PATH_ASSET_SENTINEL_FLEET_WORK_ORDER_TYPES,
						// icon: <Build />,
						permission: { area: "codes", key: "Work Order Types" },
						data: {
							serviceName: "code-per-work-order-types",
							stateName: "workOrderTypesCodes",
							tableName: "Work Order Types Codes",
							columnOrderKey:
								"workOrderTypesCodeTableColumnOrder",
							columnSizeKey: "workOrderTypesCodeTableColumnSizes",
							columnVisibilityKey:
								"workOrderTypesCodeTableColumnVisibility",
							tableSortModelKey:
								"workOrderTypesCodeTableSortModel",
							title: "Work Order Types",
						},
					},
					{
						label: "Work Order Statuses",
						tooltip: "Work Order Statuses",
						link: PATH_ASSET_SENTINEL_FLEET_WORK_ORDER_STATUS,
						// icon: <Assignment />,
						permission: {
							area: "codes",
							key: "Work Order Statuses",
						},
						data: {
							serviceName: "code-per-work-order-status",
							stateName: "workOrderStatusCodes",
							tableName: "Work Order Status Codes",
							columnOrderKey:
								"workOrderStatusCodeTableColumnOrder",
							columnSizeKey:
								"workOrderStatusCodeTableColumnSizes",
							columnVisibilityKey:
								"workOrderStatusCodeTableColumnVisibility",
							tableSortModelKey:
								"workOrderStatusCodeTableSortModel",
							title: "Work Order Status",
						},
					},
					{
						label: "Vehicle Service Requirements",
						tooltip: "Vehicle Service Requirements",
						link: PATH_ASSET_SENTINEL_FLEET_VEHICLE_SERVICE_REQUIREMENTS,
						// icon: <CarRepair />,
						permission: {
							area: "codes",
							key: "Vehicle Service Requirements",
						},
						data: {
							serviceName:
								"code-per-vehicle-service-requirements",
							stateName: "vehicleServiceRequirementsCodes",
							tableName: "Vehicle Service Requirements Codes",
							columnOrderKey:
								"vehicleServiceRequirementsCodeTableColumnOrder",
							columnSizeKey:
								"vehicleServiceRequirementsCodeTableColumnSizes",
							columnVisibilityKey:
								"vehicleServiceRequirementsCodeTableColumnVisibility",
							tableSortModelKey:
								"vehicleServiceRequirementsCodeTableSortModel",
							title: "Vehicle Service Requirements",
						},
					},
				],
			},
		],
	},
	{
		label: "Equipment",
		tooltip: "Equipment",
		link: PATH_ASSET_SENTINEL_EQUIPMENT_DASHBOARD,
		isAssetSentinelModule: true,
		icon: "toolbox",
		permission: { area: "modules", key: "Equipment" },
		subMenu: [
			{
				label: "Dashboard",
				tooltip: "Dashboard",
				link: PATH_ASSET_SENTINEL_EQUIPMENT_DASHBOARD,
				icon: "home",
				alwaysVisible: true,
				// permission: { area: "equipment", key: "Equipment" },
			},
			{
				label: "Equipment",
				tooltip: "Equipment",
				link: PATH_ASSET_SENTINEL_EQUIPMENT,
				icon: "toolbox",
				permission: { area: "equipment", key: "Equipment" },
			},
			{
				label: "Maintenance",
				tooltip: "Maintenance",
				link: PATH_ASSET_SENTINEL_EQUIPMENT_MAINTENANCE,
				icon: "tools",
				permission: { area: "equipment", key: "Maintenance" },
			},
			{
				label: "Dispensable Items",
				tooltip: "Dispensable Items",
				link: PATH_ASSET_SENTINEL_EQUIPMENT_DISPENSABLE_ITEMS,
				icon: "box",
				permission: { area: "equipment", key: "Dispensable Items" },
			},
			{
				label: "Funding Source",
				tooltip: "Funding Source",
				icon: "wallet",
				link: PATH_ASSET_SENTINEL_EQUIPMENT_FUNDING_SOURCES,
				permission: { area: "equipment", key: "Funding Sources" },
			},
			{
				label: "Code Maintenance",
				tooltip: "Code Maintenance",
				icon: "cog",
				link: PATH_ASSET_SENTINEL_EQUIPMENT_TYPES,
				permission: { area: "equipment", key: "Code Maintenance" },
				subMenu: [
					{
						label: "Equipment Types",
						tooltip: "Equipment Types",
						link: PATH_ASSET_SENTINEL_EQUIPMENT_TYPES,
						// icon: <Settings />,
						permission: { area: "codes", key: "Equipment Types" },
						data: {
							serviceName: "code-per-equipment-types",
							stateName: "equipmentTypesCodes",
							tableName: "Equipment Types Codes",
							columnOrderKey:
								"equipmentTypesCodeTableColumnOrder",
							columnSizeKey: "equipmentTypesCodeTableColumnSizes",
							columnVisibilityKey:
								"equipmentTypesCodeTableColumnVisibility",
							tableSortModelKey:
								"equipmentTypesCodeTableSortModel",
							title: "Equipment Types",
						},
					},
					{
						label: "Equipment Statuses",
						tooltip: "Equipment Statuses",
						link: PATH_ASSET_SENTINEL_EQUIPMENT_STATUS,
						// icon: <CheckCircle />,
						permission: {
							area: "codes",
							key: "Equipment Statuses",
						},
						data: {
							serviceName: "code-per-equipment-status",
							stateName: "equipmentStatusCodes",
							tableName: "Equipment Status Codes",
							columnOrderKey:
								"equipmentStatusCodeTableColumnOrder",
							columnSizeKey:
								"equipmentStatusCodeTableColumnSizes",
							columnVisibilityKey:
								"equipmentStatusCodeTableColumnVisibility",
							tableSortModelKey:
								"equipmentStatusCodeTableSortModel",
							title: "Equipment Status",
						},
					},
					{
						label: "Equipment Conditions",
						tooltip: "Equipment Conditions",
						link: PATH_ASSET_SENTINEL_EQUIPMENT_CONDITIONS,
						// icon: <Report />,
						permission: {
							area: "codes",
							key: "Equipment Conditions",
						},
						data: {
							serviceName: "code-per-equipment-conditions",
							stateName: "equipmentConditionsCodes",
							tableName: "Equipment Conditions Codes",
							columnOrderKey:
								"equipmentConditionsCodeTableColumnOrder",
							columnSizeKey:
								"equipmentConditionsCodeTableColumnSizes",
							columnVisibilityKey:
								"equipmentConditionsCodeTableColumnVisibility",
							tableSortModelKey:
								"equipmentConditionsCodeTableSortModel",
							title: "Equipment Conditions",
						},
					},
					{
						label: "Equipment Category",
						tooltip: "Equipment Category",
						link: PATH_ASSET_SENTINEL_EQUIPMENT_CATEGORY,
						// icon: <Category />,
						permission: {
							area: "codes",
							key: "Equipment Category Codes",
						},
						data: {
							serviceName: "code-per-equipment-category",
							stateName: "equipmentCategoryCodes",
							tableName: "Equipment Category Codes",
							columnOrderKey:
								"equipmentCategoryCodeTableColumnOrder",
							columnSizeKey:
								"equipmentCategoryCodeTableColumnSizes",
							columnVisibilityKey:
								"equipmentCategoryCodeTableColumnVisibility",
							tableSortModelKey:
								"equipmentCategoryCodeTableSortModel",
							title: "Equipment Category",
						},
					},
					{
						label: "Equipment Service Requirements",
						tooltip: "Equipment Service Requirements",
						link: PATH_ASSET_SENTINEL_EQUIPMENT_SERVICE_REQUIREMENTS,
						// icon: <Engineering />,
						permission: {
							area: "codes",
							key: "Equipment Service Requirements",
						},
						data: {
							serviceName:
								"code-per-equipment-service-requirements",
							stateName: "equipmentServiceRequirementsCodes",
							tableName: "Equipment Service Requirements Codes",
							columnOrderKey:
								"equipmentServiceRequirementsCodeTableColumnOrder",
							columnSizeKey:
								"equipmentServiceRequirementsCodeTableColumnSizes",
							columnVisibilityKey:
								"equipmentServiceRequirementsCodeTableColumnVisibility",
							tableSortModelKey:
								"equipmentServiceRequirementsCodeTableSortModel",
							title: "Equipment Service Requirements",
						},
					},
				],
			},
		],
	},
];

export default menuSettings;
